import { cloneDeep } from 'lodash';
import { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ticketActions from 'noc/tickets/actions';
import Toolbar from 'noc/components/toolbar';
import Loader from 'noc/components/loader';
import ServerFilterBar from 'noc/components/filter-bar';
import Error from 'noc/error/index';
import FilterAndViews from 'noc/tickets/components/filters-and-views';
import Grid from 'noc/tickets/components/grid';
import classNames from 'classnames';
import DashboardHeader from 'noc/tickets/components/DashboardHeader';
import TicketsTechniciansPanel from 'noc/tickets/components/TicketsTechniciansPanel';
import NotificationsPanel from 'noc/tickets/components/NotificationsPanel';
import Request from 'noc/common/request';

class Tickets extends Component {
    componentWillMount() {
        const { query } = this.props.location;
        let isOpenAMEnabled = this.isOpenAMEnabled();
        let isOpenAMPlusEnabled=this.isOpenAMPlusEnabled();
        if (isOpenAMEnabled && isOpenAMPlusEnabled=='1') {
            const key = this.getCookie("iPlanetDirectoryPro");
            this.props.getAuthenticatedUnquieKey(key);
        }
        else if(isOpenAMEnabled && isOpenAMPlusEnabled=='2')
        {
            const key = this.getCookie("iPlanetDirectoryProPlus");
            this.props.getAuthenticatedUnquieKey(key);
        }
        else
        {
            if (query.strSessionId != null && query.strSessionId !== undefined && query.strSessionId !== '') {
                this.props.getAuthenticatedUnquieKey(query.strSessionId);
            } else {
                this.props.loadErrorMessage('Login in NOC', 'Please login in NOC to access Ticket Tracking Dashboard', true, false);
            }
        }
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    isOpenAMEnabled() {
        return window.isOpenAMEnabled();
    }

    isOpenAMPlusEnabled()
    {
        return window.isOpenAMPlusEnabled();
    }

    componentDidMount() {
        this.props.startResetTimer('ticketTechniciansPanel');
        this.props.startResetTimer('notificationsPanel');

        document.addEventListener("keydown", this.props.pageKeyPress.bind(this));

        const div = document.createElement("div");
        div.setAttribute("style", "height:1px;color:#f5f5f5;font-size:1px;");
        document.body.appendChild(div);

        let repaintTimer = null;
        let repaintScreen = function ()
        {
          div.innerHTML = new Date().toLocaleTimeString();
        };
        window.onblur = function()  {
            repaintTimer = setInterval(function() { repaintScreen() }, 1000);
        };

        function stopInterval() {
            clearInterval(repaintTimer);
        }
        window.onfocus = function() { stopInterval(); };
    }

    renderLinkSet() {
        const { columnFilters, toggle, dataSearch, requestForId,
                tabsData, isFilterChecked, onCheckedOfColumnFilter,
                getFilteredData, refresh, setElapsedTime, elapsed,fetchTicketCountData,
                onTextFilter, ticketCategoryData,getTabData,ticketCheckboxArray,ticketsData,OwnerTeamData} = this.props;

        return (<FilterAndViews
            columnFilters={columnFilters}
            toggle={toggle}
            dataSearch={dataSearch}
            requestForId={requestForId}
            tabsData={tabsData}
            isFilterChecked={isFilterChecked}
            getFilteredData={getFilteredData}
            onCheckedOfColumnFilter={onCheckedOfColumnFilter}
            onTextFilter={onTextFilter}
            refresh={refresh}
            setElapsedTime={setElapsedTime}
            elapsed={elapsed}
            ticketCategoryData={ticketCategoryData}
			getTabData={getTabData}
            ticketCheckboxArray={ticketCheckboxArray}
            ticketsData={ticketsData}
			OwnerTeamData={OwnerTeamData}
            fetchTicketCountData={fetchTicketCountData}
        />);
    }

    renderTable() {
        const {

            getAllData,
            tabsData,
            ticketsData,
            dataSort,
            sortOrders,
            requestForId,
            showErrorMessage,
            errorTitle,
            errorMessage,
            totalPages,
            pageNumber,
            totalCount,
            printTicket,
            openTicket,
            renderRemainingTime,
            renderSLA, renderSLAZONE, firstItem, lastItem, pageNumberChange, footerPosition,IsSLM,OwnerTeamData,ticketCheckboxArray,IsSLMOwnerTeam
        } = this.props;

        let tabData;
        tabsData.forEach(tab => {
            if (tab.Id === requestForId) {
                tabData = tab;
            }
        });
        if (tabData == null || tabData.QueueViewGrid == null) {
            return false;
        }

        return ((showErrorMessage === true)
            ? <Error errorTitle={errorTitle} errorMessage={errorMessage} />
            :
            <Grid
                name="grid"
                ticketsData={ticketsData} tabsData={tabsData} requestForId={requestForId} getAllData={getAllData}
                dataSort={dataSort} sortOrders={sortOrders}
                renderRemainingTime={renderRemainingTime} renderSLA={renderSLA}
                renderSLAZONE={renderSLAZONE}
                totalPages={totalPages} totalCount={totalCount}
                firstItem={firstItem} lastItem={lastItem}
                pageNumber={pageNumber} pageNumberChange={pageNumberChange}
                printTicket={printTicket}
                openTicket={openTicket}
                strSessionId={this.props.location}
                footerPosition={footerPosition}
				IsSLM={IsSLM}
				OwnerTeamData={OwnerTeamData}
				ticketCheckboxArray={ticketCheckboxArray}
				IsSLMOwnerTeam={IsSLMOwnerTeam}
            />
        );
    }

    renderView() {
        const {
            filterList,
            columnFilters,
            tabsData,
            getTabData,
            requestForId,
            filtersData,
            onCheckedOfColumnFilter,
            onTextFilter,
            getFilteredData,
            ticketsData,
            showErrorMessage,
            showLoginError,
            errorTitle,
            errorMessage,
            toggle,
            showMorePopup,
            tabsToBeShown,
            saveNewTab,
            removeTab,
            swapCustomTabs,
            errors,
            clearErrors,
            editTab,
            clearFilters,
            filteredDataColumns,
            TechStatusData,
            TicketPlayStatusData,
            refreshTechnician,
            OwnerTeamData,
            CellData,
            UserDetails,
            fetchTicketTechData,
            refreshGrid,
            refresh,
            changeOwnerTeam, changeCell,
            ticketCategoryData,
            refreshCategoryGridTime,
            dataRequestsTokens,
			IsSLM
        } = this.props;

        const tabFilter = columnFilters.find(x => x.eventName === 'TabFilter');
        const saveNewView = columnFilters.find(x => x.eventName === 'saveNewView');
        const morePopupStatus = columnFilters.find(x => x.eventName === 'morePopupView');
        const manageView = columnFilters.find(x => x.eventName === 'manageView');
        const now = new Date();
        const RefreshGridTime = now.toTimeString().split(' ')[0];

        const classFilter = classNames(
            tabFilter.isStatus === true ? 'cn-page__main noc-page__main--fixed' : 'cn-page__main'
        );

        return (
            <div className="cn-page__layout noc-page__layout" style={{ minHeight: '100vh' }}>
                {(showLoginError === true)
                    ? <Error errorTitle={errorTitle} errorMessage={errorMessage} />
                    : (ticketsData.length === 0 && showErrorMessage === false)
                        ? <Loader />
                        : <div className={classFilter}>
                            { dataRequestsTokens.length > 0 ? <Loader /> : '' }

                            <DashboardHeader
                                OwnerTeamData={OwnerTeamData}
                                CellData={CellData}
                                UserDetails={UserDetails}
                                fetchTicketTechData={fetchTicketTechData}
                                refresh={refresh}
                                changeOwnerTeam={changeOwnerTeam}
                                changeCell={changeCell}
                            />

                            <div className="page-content">

                                <TicketsTechniciansPanel
                                    TicketPlayStatusData={TicketPlayStatusData}
                                    TechStatusData={TechStatusData}
                                    refreshTechnician={refreshTechnician}
                                    UserDetails={UserDetails}
                                    fetchTicketTechData={fetchTicketTechData}
                                />

                                <NotificationsPanel
                                    tabs={tabsData}
                                    getTabData={getTabData}
                                    requestForId={requestForId}
                                    showMorePopup={showMorePopup}
                                    tabsToBeShown={tabsToBeShown}
                                    toggle={toggle}
                                    columnFilters={columnFilters}
                                    morePopupStatus={morePopupStatus.isStatus}
                                    swapCustomTabs={swapCustomTabs}
                                    refreshGrid={refreshGrid}
                                    RefreshGridTime={RefreshGridTime}
                                    ticketCategoryData={ticketCategoryData}
                                    refreshCategoryGridTime={refreshCategoryGridTime}
                                />
                                <Toolbar>
                                    {this.renderLinkSet()}
                                </Toolbar>

                                <ServerFilterBar
                                    tabsData={tabsData}
                                    filterMenu={tabFilter}
                                    filterList={filterList}
                                    filtersData={filtersData}
                                    requestForId={requestForId}
                                    getFilteredData={getFilteredData}
                                    onCheckedOfColumnFilter={onCheckedOfColumnFilter}
                                    onTextFilter={onTextFilter}
                                    saveNewView={saveNewView.isStatus}
                                    toggle={toggle}
                                    columnFilters={columnFilters}
                                    manageView={manageView.isStatus}
                                    saveNewTab={saveNewTab}
                                    removeTab={removeTab}
                                    errors={errors}
                                    clearErrors={clearErrors}
                                    editTab={editTab}
                                    clearFilters={clearFilters}
                                    filteredDataColumns={filteredDataColumns}
									OwnerTeamData={OwnerTeamData}
                                />
                                {this.renderTable()}
                            </div>
                        </div>
                }
            </div>
        );
    }

    render() {
        return (this.renderView(this));
    }
}

Tickets.propTypes = {
    isFilterChecked: PropTypes.bool,
    requestForId: PropTypes.string,
    ticketsData: PropTypes.arrayOf(PropTypes.object),
    ticketCheckboxArray:PropTypes.arrayOf(PropTypes.number),
    tabsData: PropTypes.arrayOf(PropTypes.object),
    filtersData: PropTypes.arrayOf(PropTypes.object),
    filterPreviousData: PropTypes.object,
    getTabData: PropTypes.func,
    getAuthenticatedUnquieKey: PropTypes.func,
    totalCount: PropTypes.number,
    dataSort: PropTypes.func,
    sortOrders: PropTypes.arrayOf(PropTypes.object),
    dataSearch: PropTypes.func,
    onCheckedOfColumnFilter: PropTypes.func,
    onTextFilter: PropTypes.func,
    getFilteredData: PropTypes.func,
    renderRemainingTime: PropTypes.func,
    renderSLA: PropTypes.func,
    renderSLAZONE: PropTypes.func,
    loadErrorMessage: PropTypes.func,
    removeTab: PropTypes.func,
    saveNewTab: PropTypes.func,
    clearErrors: PropTypes.func,
    toggle: PropTypes.func,
    errorMessage: PropTypes.string,
    errorTitle: PropTypes.string,
    showErrorMessage: PropTypes.bool,
    showLoginError: PropTypes.bool,
    filterList: PropTypes.arrayOf(PropTypes.object),
    columnFilters: PropTypes.arrayOf(PropTypes.object),
    showMorePopup: PropTypes.bool,
    tabsToBeShown: PropTypes.number,
    editTab: PropTypes.func,
    swapCustomTabs: PropTypes.func,
    refresh: PropTypes.func,
    setElapsedTime: PropTypes.func,
    printTicket: PropTypes.func,
    clearFilters: PropTypes.func,
    openTicket: PropTypes.func,
    footerPosition: PropTypes.number,
    filteredDataColumns: PropTypes.func,
    TechStatusData: PropTypes.object,
    TicketPlayStatusData: PropTypes.object,
    refreshTechnician: PropTypes.func,
    OwnerTeamData: PropTypes.arrayOf(PropTypes.object),
    CellData: PropTypes.arrayOf(PropTypes.object),
    ticketCategoryData: PropTypes.arrayOf(PropTypes.object),
    refreshCategoryGridTime:PropTypes.string,
    UserDetails:PropTypes.object,
    fetchTicketTechData:PropTypes.func,
    refreshGrid: PropTypes.func,
    refresh:PropTypes.func,
    changeOwnerTeam: PropTypes.func,
    dataRequestsTokens: PropTypes.arrayOf(Number),
    startResetTimer: PropTypes.func,
	IsSLM : PropTypes.bool,
    IsSLMOwnerTeam : PropTypes.bool
};

const selectors = state => {
    const ticketsData = cloneDeep(state.tickets.ticketsData);
    const ticketCheckboxArray=cloneDeep(state.tickets.ticketCheckboxArray);
    const tabsData = cloneDeep(state.tickets.tabsData);
    const filtersData = cloneDeep(state.tickets.filtersData);
    const ticketCategoryData = cloneDeep(state.tickets.ticketCategoryData);
    return {
        ticketsData,
        ticketCheckboxArray,
        tabsData,
        filtersData,
        ticketCategoryData,
        refreshCategoryGridTime: state.tickets.refreshCategoryGridTime,
        columnFilterMenu: state.tickets.columnFilterMenu,
        currentPage: state.tickets.currentPage,
        firstItem: state.tickets.firstItem,
        lastItem: state.tickets.lastItem,
        pageCount: state.tickets.pageCount,
        pageNumber: state.tickets.pageNumber,
        pageSize: state.tickets.pageSize,
        sortColumn: state.tickets.sortColumn,
        sortDirection: state.tickets.sortDirection,
        sortOrders: state.tickets.sortOrders,
        startIndex: state.tickets.startIndex,
        totalCount: state.tickets.totalCount,
        totalPages: state.tickets.totalPages,
        isFilterChecked: state.tickets.isFilterChecked,
        requestForId: state.tickets.requestForId,
        Enckey: state.tickets.Enckey,
        errorMessage: state.tickets.errorMessage,
        errorTitle: state.tickets.errorTitle,
        showErrorMessage: state.tickets.showErrorMessage,
        showLoginError: state.tickets.showLoginError,
        filterList: state.tickets.filterList,
        filterPreviousData: state.tickets.filterPreviousData,
        columnFilters: state.tickets.columnFilters,
        showMorePopup: state.tickets.showMorePopup,
        tabsToBeShown: state.tickets.tabsToBeShown,
        errors: state.tickets.errors,
        startTime: state.tickets.startTime,
        elapsed: state.tickets.elapsed,
        UserDetails: state.tickets.UserDetails,
        footerPosition: state.tickets.footerPosition,
        TechStatusData: state.tickets.TechStatusData,
        TicketPlayStatusData: state.tickets.TicketPlayStatusData,
        refreshTechnician: state.tickets.refreshTechnician,
        OwnerTeamData: state.tickets.OwnerTeamData,
        CellData: state.tickets.CellData,
        UserDetails: state.tickets.UserDetails,
        dataRequestsTokens: state.tickets.dataRequestsTokens,
		IsSLM:state.tickets.IsSLM,
        IsSLMOwnerTeam:state.tickets.IsSLMOwnerTeam
    };
};

export default connect(selectors, {
    ...ticketActions
})(Tickets);



// WEBPACK FOOTER //
// ./app/tickets/index.jsx